import {
   GET_LIST_TYPE_DOCUMENTS,
   CHANGE_VALUE_INPUTS_FORM,
   SELECTED_ITEMS_CATEGORIES,
   SAVE_TYPE_DOCUMENT,
   GET_ITEM_TYPE_DOCUMENT,
   DELETE_ITEM_TYPE_DOCUMENT,
   DISABLED_CATEGORY_RELATED,
   TYPE_DOCUMENTS_DEFAULT_DATA,
   SELECTED_GENERAL_CONCEPTS,
   DISABLED_GENERAL_CONCEPT_RELATED,
   SELECTED_CONCEPT_DISCOUNT,
   DISABLED_DISCOUNT_CONCEPT_RELATED
} from '../constants/catalogue_type_documents';

export const catalogue_type_documents = ( state = {}, action ) => {
   switch ( action.type ) { 

      case GET_LIST_TYPE_DOCUMENTS : {
         return action.payload;
      }

      case CHANGE_VALUE_INPUTS_FORM : {
         return action.payload;
      }

      case SELECTED_ITEMS_CATEGORIES : {
         return action.payload;
      }

      case SAVE_TYPE_DOCUMENT : {
         return action.payload;
      }

      case GET_ITEM_TYPE_DOCUMENT : {
         return action.payload;
      }

      case DELETE_ITEM_TYPE_DOCUMENT : {
         return action.payload;
      }

      case DISABLED_CATEGORY_RELATED : {
         return action.payload;
      }
      
      case TYPE_DOCUMENTS_DEFAULT_DATA : {
         return action.payload;
      }

      case SELECTED_GENERAL_CONCEPTS : {
         return action.payload;
      }

      case DISABLED_GENERAL_CONCEPT_RELATED : {
         return action.payload;
      }

      case SELECTED_CONCEPT_DISCOUNT: {
         return action.payload;
      }

      case DISABLED_DISCOUNT_CONCEPT_RELATED : {
         return action.payload;
      }
 
     default :
     return state;
   }
}


